import { ShoppingIcon } from './ShoppingIcon';

/**
 * author: Google
 * id 7A5ED547-B142-4921-8050-647B2B9F4DC0
 * name shopping
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shopping.svg
 * tags
 * - Shopping 
 */
export const MarketplaceIcon = ShoppingIcon;
export default MarketplaceIcon